import { Redirect, useLocalSearchParams } from 'expo-router';

import { AuthContainer, SignUp } from '@fhs/auth';

export default function SignUpPage() {
  const { loginJwt } = useLocalSearchParams<{ loginJwt?: string }>();
  if (!loginJwt) {
    return <Redirect href="/v2/signin" />;
  }
  return (
    <AuthContainer>
      <SignUp />
    </AuthContainer>
  );
}
